import { ApiResponseType } from '@/api/type/commonTypes';
import { GetPartnerLanguagesResponse } from '../type/types';
import { api } from '../axiosInstance';

export const getPartnerLanguages = async () => {
  const res = await api.get<ApiResponseType<GetPartnerLanguagesResponse[]>>(
    '/api/web/partners/profile/languages'
  );
  return res.data;
};
